module.exports = __webpack_public_path__ + "img/312.c71a534e.jpg";